import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import 'firebase/compat/firestore';
import 'firebase/compat/functions';
import 'firebase/compat/storage';

const firebaseConfig = {
  apiKey: "AIzaSyAcJBEv6GEcL87LaszlZfuMgDjiolSV5FA",
  authDomain: "qms-app-456e3.firebaseapp.com",
  projectId: "qms-app-456e3",
  storageBucket: "qms-app-456e3.firebasestorage.app",
  messagingSenderId: "691605190507",
  appId: "1:691605190507:web:96ef4544577807d90c7e2e",
  measurementId: "G-2GFYEEDL5Y"
};

// Initialize Firebase (compat SDK)
if (!firebase.apps.length) {
  firebase.initializeApp(firebaseConfig);
}

// console statement removed for production

// Export default firebase for components that import it
export default firebase;
